import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContactAvatar from '../../../../../../components-new/general/ContactAvatar';
import {getContactFromConversation} from '../../../../../../utils/ComponentUtilFunctions';
import './styles.css';

/*
 * How long the row takes to open and to shut. Must match the transition on
 * .typing-indicator in styles.css - the view is walked down over the same
 * stretch, so the two have to agree or the scroll arrives before the row does.
 */
const OPEN_MS = 300;

/* within this far from the foot the conversation counts as being read at the
   bottom, and is kept there */
const AT_BOTTOM_PX = 80;

function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

class TypingIndicator extends Component {
    /*
     * Walks the view down to the foot over the same stretch the row takes to
     * open.
     *
     * The foot is read again on every frame rather than once at the start: the
     * row is growing underneath while this runs, so where the bottom is keeps
     * changing. A target taken up front would be the bottom as it was before
     * the row existed, and the view would stop a row short of it.
     */
    scrollToBottom = (container, duration) => {
        cancelAnimationFrame(this.frame);

        const from = container.scrollTop;
        const start = performance.now();

        const step = now => {
            const progress = Math.min(1, (now - start) / duration);
            const target = container.scrollHeight - container.clientHeight;

            container.scrollTop = from + (target - from) * easeInOutCubic(progress);

            if (progress < 1) {
                this.frame = requestAnimationFrame(step);
            }
        };

        this.frame = requestAnimationFrame(step);
    };

    componentDidUpdate(prevProps) {
        const { activeTypingConvIds, conversationId, messageWindow } = this.props;

        const wasVisible = prevProps.activeTypingConvIds.includes(conversationId);
        const isVisible = activeTypingConvIds.includes(conversationId);

        if (wasVisible === isVisible) return;
        if (!messageWindow || !messageWindow.current) return;

        const container = messageWindow.current;

        /*
         * Only when the foot is what is being read. Someone up in the history
         * has not asked to be taken anywhere, and the row opening below them is
         * not a reason to move the page out from under them.
         *
         * On the way out there is nothing to do: the row shutting shortens the
         * content, and a view already at the foot is held there by the browser
         * as it shortens - it follows the row down on its own.
         */
        if (!isVisible) return;

        const distanceFromBottom =
            container.scrollHeight - container.scrollTop - container.clientHeight;

        if (distanceFromBottom < AT_BOTTOM_PX) {
            this.scrollToBottom(container, OPEN_MS);
        }
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.frame);
    }

    render() {
        const { activeTypingConvIds, conversationId, conversation } = this.props;

        const isVisible = activeTypingConvIds.includes(conversationId);
        const contact = conversation ? getContactFromConversation(conversation) : {};

        /*
         * Always here, typing or not.
         *
         * It used to be mounted when the visitor started and dropped when they
         * stopped, and a row that is dropped has no leaving to do - it was gone
         * in the frame it stopped being rendered, and the conversation shut over
         * the hole in one step. Kept in the list with no height instead: a height
         * that opens is a height that can be transitioned, and the rest of the
         * conversation moves up out of its way rather than jumping.
         */
        return (
            <div className={'typing-row' + (isVisible ? ' is-visible' : '')}
                 aria-hidden={!isVisible}>
                {/* the classes of a received message, so that what arrives in its
                    place is the same bubble at the same place on the line */}
                <div className="message received">
                    <div className="avatar-wrapper">
                        <ContactAvatar contact={contact} variant="chat"/>
                    </div>
                    <div>
                        <div className="message-content typing-row__bubble">
                            <span className="typing-dots typing-row__dots">
                                <span/><span/><span/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    activeTypingConvIds: state.chat.activeTypingConvIds,
});

export default connect(mapStateToProps)(TypingIndicator);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/TypingIndicator/index.jsx